import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { APIManager } from '@flashvpn-io/web-core';
import { AppConfigService } from '../../services/app-config.service';


type LanguageCode = 'zh-CN' | 'zh-TW' | 'en-US' | 'ru-RU';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  showLanguageSelector = false;
  currentLanguage = '';
  version = '1.0.0'; // 当前版本
  latestVersion = '';
  updateAvailable = false;
  downloadUrl = '';

  private readonly languageMap: Record<LanguageCode, string> = {
    'zh-CN': '简体中文',
    'zh-TW': '繁體中文',
    'en-US': 'English',
    'ru-RU': 'Русский'
  };

  constructor(
    private translate: TranslateService,
    private apiManager: APIManager,
    private appConfigService: AppConfigService
  ) { }

  ngOnInit() {
    // 从本地存储获取保存的语言
    const savedLang = localStorage.getItem('selectedLanguage') as LanguageCode;
    if (savedLang && this.languageMap[savedLang]) {
      this.currentLanguage = this.languageMap[savedLang];
    } else {
      const currentLang = this.translate.currentLang as LanguageCode;
      this.currentLanguage = this.languageMap[currentLang] || currentLang;
    }

    // 监听语言变化
    this.translate.onLangChange.subscribe(() => {
      const currentLang = this.translate.currentLang as LanguageCode;
      this.currentLanguage = this.languageMap[currentLang] || currentLang;
    });

    // 自动检测最新版本
    this.getLatestVersion();
  }

  toggleLanguageSelector() {
    this.showLanguageSelector = !this.showLanguageSelector;
  }

  onLanguageChange() {
    this.showLanguageSelector = false;
    // 更新显示的语言名称
    const currentLang = this.translate.currentLang as LanguageCode;
    console.log('currentLang', currentLang);
    this.currentLanguage = this.languageMap[currentLang] || currentLang;
  }

  getLatestVersion() {
    this.apiManager.getAppVersion('chrome').subscribe({
      next: (version) => {
        this.latestVersion = version.short_version;
        // 拼接下载地址
        if (version.download_url) {
          this.downloadUrl = version.download_url.startsWith('http')
            ? version.download_url
            : this.appConfigService.getApiUrl().replace(/\/$/, '') + (version.download_url.startsWith('/') ? '' : '/') + version.download_url;
        } else {
          this.downloadUrl = '';
        }
        this.updateAvailable = this.compareVersion(this.latestVersion, this.version) > 0;
      },
      error: (error) => {
        console.error('获取最新版本失败', error);
        this.latestVersion = this.version;
        this.downloadUrl = '';
        this.updateAvailable = false;
      }
    });
  }

  // 版本号对比：v1 > v2 返回1，v1 = v2 返回0，v1 < v2 返回-1
  compareVersion(v1: string, v2: string): number {
    if (!v1 || !v2) return 0;
    const a1 = v1.split('.').map(Number);
    const a2 = v2.split('.').map(Number);
    for (let i = 0; i < Math.max(a1.length, a2.length); i++) {
      const n1 = a1[i] || 0;
      const n2 = a2[i] || 0;
      if (n1 > n2) return 1;
      if (n1 < n2) return -1;
    }
    return 0;
  }
}